import {Col, Row, Checkbox, Card} from "antd";
import Text from "antd/es/typography/Text";
import folder from "../resources/img/folder.svg";
import pdf from '../resources/img/pdf.svg';
import up from '../resources/img/up.svg';
import auth from "../const/auth";
import newBase64Logo from '../resources/img/new-logo-menu.png'
import newBase64LogoDark from '../resources/img/new-logo-login.png'

export const getBase64File= (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () =>{
            let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
            if ((encoded.length % 4) > 0) {
                encoded += '='.repeat(4 - (encoded.length % 4));
            }
            resolve(encoded);
        };
        reader.onerror = error => reject(error);
    });
}

export const isMobile=()=>
{
    return window.innerWidth<500;
};

export const addFileName=(props,text)=>
{
    if(props.uploadFilesInfo.length>props.documents.length)
        text= text.replace('{0}',props.uploadFilesInfo[props.documents.length].fileName);
    if(text.includes('{0}'))
        text="Cargar documento";
    return text;
};

export const addUpButton=(stateParentId,propsParentId,entries)=>
{
    if(entries)
    {
        let upLevel={key:'upbutton' + stateParentId,id: propsParentId, uid: '', name: '...',folder:true};
        if(entries.length>0)
        {
            if (stateParentId && entries[0].name!=='...')
                entries.unshift(upLevel);
        }
        else if (stateParentId)
            entries.push(upLevel);
    }
    return entries;
};

export const renderTemplates=(title,templates,onChange,onEnter,onUp,colsLength=4,ids)=>
{
    if(!templates || templates.length===0)
        return;
    if(window.innerWidth<800 && colsLength>4)
        colsLength=4;
    let i=0,rows=[],rowsLength=1;
    if(templates.length>colsLength)
        rowsLength=Math.ceil(templates.length/colsLength);
    for(let j=0;j<rowsLength;j++)
    {
        let cols=[];
        for(let k=0;k<colsLength && i<templates.length;k++)
        {
            cols.push(<Col key={'col'+k} span={24/colsLength}>{renderCard(templates[i],onChange,onEnter,onUp,ids)}</Col>);
            i++;
        }
        rows.push(cols);
    }
    const newRows=rows.map((row,index)=><Row key={index} style={{marginTop:'10px',marginBottom:'10px'}} gutter={{ xs: 2, sm: 10, md: 18, lg: 26 }}>{row.map((col)=>col)}</Row>);
    newRows.unshift(<Row key={'selecttemplatekey'}>{title}</Row>);
    return newRows;
};

const renderCard=(template,onChange,onEnter,onUp,ids)=>
{
    let image=folder;
    let checked=false;
    const isFolder=template.folder;
    const isUpButton=template.name==='...';
    const callback=()=>onEnter(template.id);
    if(isFolder)
    {
        if(isUpButton)
            image=up;
    }
    else
    {
        image = pdf;
        checked=ids.includes(template.id);
    }
    return <Card onDoubleClick={isFolder?(isUpButton?onUp:callback):null} style={{background:'rgb(245,245,245)', height:'100%', padding:'20px'}}
                 hoverable bodyStyle={{padding:0,textAlign:'center',height:'100%'}}
    >
        <Row justify="space-around" align="middle" style={{height:'100%'}}>
            <Col span={24}><img alt="example" src={image} /></Col>
            <Col span={24}>{!isFolder?<Checkbox checked={checked} onChange={(e)=>onChange(template.id,e.target.checked)}/>:''}</Col>
            <Col span={24}><Text style={{wordWrap:'break-word',fontSize:'12px'}}>{template.name}</Text></Col>
        </Row>
    </Card>;
};

export const getStorageCustomization = () => {
    const storageCustomization = window.localStorage.getItem('customization');
    return storageCustomization ? (JSON.parse(storageCustomization)) : {};
}


export const getCustomColors = (newCustomColors, defaultValues = false) => {
    const labels = ['colorPrimary', 'colorSecondary', 'colorPanels', 'colorMenu', 'colorTextPrimary', 'colorTextSecondary', 'colorTextPanels', 'colorTextMenu','colorPrimaryOpacity'];
    const customization = defaultValues ? {} : (newCustomColors ? newCustomColors : getStorageCustomization());
    const colors = {}
    labels.map(label => colors[label] = customization && customization[label] ? customization[label] : getComputedStyle(document.documentElement).getPropertyValue(`--default-${label}`))
    return colors;
}

export const getCustomMessages = (language, defaultValues = false) => {
    const labels = ['messageHome', 'messageHome1', 'messageHome2']
    const customization = defaultValues ? {} : getStorageCustomization()
    const messages = {};
    labels.map(label => messages[label] = customization[label] ? customization[label] : auth[language][label]);
    return messages;
}

export const getCustomLogos = (defaultValues = false) => {
    const defaultLogos = { 'base64Logo': newBase64Logo, 'base64LogoDark': newBase64LogoDark }
    const customization = defaultValues ? {} : getStorageCustomization()
    const logos = {};
    Object.keys(defaultLogos).map(label => logos[label] = customization[label] ? customization[label] : defaultLogos[label])
    return logos;
}

export const getDefaultCustom = (language = 'es') => {
    return [getCustomLogos(true), getCustomMessages(language, true), getCustomColors(null, true)]
}